module.exports = __webpack_public_path__ + "static/media/video.8ba1aa15.mp4";